import { createAsyncThunk } from "@reduxjs/toolkit";
import _map from 'lodash/map';
import _isEmpty from 'lodash/isEmpty';

export const asyncThunkWrapper = ({ model, action, func }) => {
  return createAsyncThunk(`${model}/${action}`, async (args, { rejectWithValue }) => {
    try {
      return await func(args);
    } catch (error) {
      const attributes = _isEmpty(error.response?.data?.error?.attributes) ? null : _map(error.response.data.error.attributes, (values, key) => `${key}: ${values.join(', ')}`).join(', ');
      const type = error.response?.data?.error?.type ?? null;
      const message = !!attributes ? attributes : error.response?.data?.error?.message ?? 'Something went wrong';
      const status = error.response?.status;

      return rejectWithValue({
        type,
        message,
        status
      });
    }
  });
};
